import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconInputForm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"input-form, text-area, prompt, rename"} maskId="square-filled-radius-0-stroke-1-IconInputForm"><path d="M9 21H8V3H9V21Z" fill="currentColor"/><path d="M6.5 18H2V6H6.5V18Z" fill="currentColor"/><path d="M22 18H10.5V6H22V18Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconInputForm;
